import carouselApi from "../../api/carousels";

const state = {
  all: []
};

const getters = {};

const actions = {
  getAllCarousels({ commit }) {
    return carouselApi.getCarousels().then(carousel => {
      commit("setCarousels", carousel.data);
      return carousel.data;
    });
  },
  getCarousel({ commit }, id) {
    carouselApi.getCarousel(id).then(carousel => {
      commit("setCarousel", carousel.data);
    });
  },
  postCarousel({ commit }, carousel) {
    return carouselApi.postCarousel(carousel).then(response => {
      commit("addCarousel", response.data);
      return response.data;
    });
  },
  putCarousel({ commit }, { id, carousel }) {
    return carouselApi.putCarousel(id, carousel).then(response => {
      commit("updateCarousel", response.data);
      return response.data;
    });
  },
  deleteCarousel({ commit }, id) {
    return carouselApi.deleteCarousel(id).then(() => {
      commit("removeCarousel", id);
    });
  },
  updateCarouselOrder({ commit }, orderData) {
    return carouselApi.updateCarouselOrder(orderData).then(response => {
      commit("setCarousels", response.data);
      return response.data;
    });
  }
};

const mutations = {
  setCarousels(state, carousels) {
    state.all = carousels;
  },
  setCarousel(state, carousel) {
    state.carousel = carousel;
  },
  addCarousel(state, carousel) {
    state.all.push(carousel);
  },
  updateCarousel(state, updatedCarousel) {
    const index = state.all.findIndex(c => c.id === updatedCarousel.id);
    if (index !== -1) {
      state.all.splice(index, 1, updatedCarousel);
    }
  },
  removeCarousel(state, id) {
    state.all = state.all.filter(c => c.id !== id);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

